import { render } from "./ChvCompanion.vue?vue&type=template&id=4567f4a8&scoped=true"
import script from "./ChvCompanion.vue?vue&type=script&lang=js"
export * from "./ChvCompanion.vue?vue&type=script&lang=js"

import "./ChvCompanion.vue?vue&type=style&index=0&id=4567f4a8&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4567f4a8"]])

export default __exports__